import async from '~/utils/async';
import resolver from './Metrics.resolver';
import Metrics from './Metrics';

export default async(resolver)(Metrics);
